import { useQuery } from '@tanstack/react-query'
import { getQueryKey } from '~/services'
import { resolveKey } from '~/services/preferences/preferences'
import {
  getWorkspacePreference,
  GetWorkspacePreferenceProps,
  WorkspacePreferences,
} from '~/services/preferences/workspacePreferences'

export const useGetWorkspacePreferences = <T extends keyof WorkspacePreferences>(
  props: GetWorkspacePreferenceProps<T>,
  workspaceId: string
) => {
  const queryKey = getQueryKey('workspaces_/$workspaceId_/preferences/$path', {
    path: resolveKey(props),
    workspaceId,
  })
  return useQuery({
    queryKey,
    queryFn: async () => {
      const result = await getWorkspacePreference(props, workspaceId)
      return result ?? false
    },
  })
}
